import React from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from 'redux-form';
import FormField from '../../forms/FormField';
import Loading from '../../ui/Loading';

const required = value => value ? undefined : 'Required';
const ClubCancelForm = (
    {
        handleSubmit,
        onCancel,
        cancelMembershipInProgress,
        cancellationOptions,
        selectedReason,
        cancelMembershipError
    }
) => {
    return (
        <form onSubmit={handleSubmit}>
        <h3  style={{ textTransform: 'none' }}>Cancel Membership</h3>
           <div className="form-group">
              <h3 className='col-md-12' style={{ textTransform: 'none', margin:"20px auto" }}>
              Are you sure you want to cancel your membership? If so, please fill out the information below.
              </h3>
          
              <div className='col-md-6 small'>  
                <Field 
                  options={cancellationOptions}
                  placeholder='Select a reason... '
                  component={FormField.SelectReact}
                  name="selectedReason"
                  label='Reason'
                  validate={[required]}
                />
              </div>

             { 
             //This is the value of the OTHER option
              ((selectedReason || '').trim() === 'X') &&
              <div className='col-md-12'> 
                <Field 
                  options={cancellationOptions}
                  placeholder='Enter a reason... '
                  component={FormField.Textarea}
                  name="customerReason"
              l   label='Customer Reason'
                  validate={[required]}
                />
              </div>}
             
            </div>
        <br />
            {cancelMembershipError && (
            <div  style={{ color: '#dc3545', margin:"10px auto"}} >
                <span>{(cancelMembershipError || {}).message}</span>  
            </div>
            )}
            <div className="form-row">
              <div className="col-md-6" style={{marginBottom:"20px"}}>
                  <button type="submit"
                      className="btn btn-primary btn-block"
                      disabled={cancelMembershipInProgress}
                  >
                      Confirm
                  </button>
              </div>
              <div className="col-md-6">
                  <button
                      type="button"
                      className="btn btn-inverse btn-block"
                      onClick={onCancel}
                      disabled={cancelMembershipInProgress}
                  >
                      Cancel
                  </button>
              </div>
              {(cancelMembershipInProgress) && <Loading />}
            </div>

          </form>
    )
}

const formName = 'club-cancel-form';
const selector = formValueSelector(formName);
const mapState = state => {
    const selectedReason = selector(state, 'selectedReason') || null;
    return {
        selectedReason
    }
}
const form = reduxForm({ form: formName, enableReinitialize: true })(ClubCancelForm);
export default connect(mapState)(form);